/**
 * Utilitaires partagés pour la normalisation des noms de thèmes.
 * Utilisé par CatalogueSolutionsPage et ChoixThemesPage.
 */

/** Normalise un nom de thème pour la correspondance fuzzy */
export function normalizeThemeName(name: string): string {
  return name
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // retire les accents
    .replace(/\s*\(.*?\)\s*/g, '')   // retire les parenthèses et leur contenu
    .replace(/[…\.]+$/, '')          // retire les points de suspension
    .trim()
}
